import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { INDUSTRIAS } from "@/lib/calc";

const wrap = { hidden: {}, show: { transition: { staggerChildren: 0.04, delayChildren: 0.08 } } };
const item = { hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: [0.22, 0.61, 0.36, 1] } } };

export default function IndustryStep({ selected, onSelect, onAdvance, onBack, testId }) {
  const [manual, setManual] = useState("");
  const [error, setError] = useState("");
  const manualRef = useRef(null);
  const esOtro = selected === "otro";

  function pick(ind) {
    setError("");
    onSelect(ind);
    if (ind.cpl === null) setTimeout(() => manualRef.current?.focus(), 60);
  }

  function avanzar(e) {
    if (e) e.preventDefault();
    if (esOtro) {
      const n = Number(manual);
      if (manual === "" || Number.isNaN(n) || n < 1) {
        setError("Escribe un CPL válido en dólares (mínimo $1).");
        manualRef.current?.focus();
        return;
      }
      onAdvance(n);
    } else {
      onAdvance(null);
    }
  }

  return (
    <section className="step" data-testid={testId}>
      <div className="step-inner">
        <motion.div variants={wrap} initial="hidden" animate="show">
          <motion.p className="eyebrow" variants={item}>
            <span className="mk-estrella" aria-hidden="true" /> Pregunta 6 de 6
          </motion.p>
          <motion.h2 className="q-title display" variants={item}>
            Industria de la marca
          </motion.h2>
          <motion.p className="hint" variants={item}>
            Define el CPL para tu número de leverage.
          </motion.p>
          <div className="grid-ind" role="radiogroup" aria-label="Industria de la marca">
            {INDUSTRIAS.map((ind) => (
              <motion.button
                key={ind.id}
                variants={item}
                type="button"
                role="radio"
                aria-checked={selected === ind.id}
                className="opcion"
                data-testid={`${testId}-opcion-${ind.id}`}
                onClick={() => pick(ind)}
              >
                <span className="op-label">{ind.label}</span>
                <span className="op-sub">{ind.cpl === null ? "…" : `~$${ind.cpl}`}</span>
              </motion.button>
            ))}
          </div>
          {esOtro ? (
            <form className="cpl-manual" onSubmit={avanzar} noValidate data-testid="cpl-manual-form">
              <label htmlFor="cpl-manual-input">CPL de la marca, en dólares.</label>
              <input
                ref={manualRef}
                id="cpl-manual-input"
                data-testid="cpl-manual-input"
                className="campo-input"
                type="number"
                inputMode="numeric"
                min="1"
                step="1"
                value={manual}
                onChange={(e) => setManual(e.target.value)}
                placeholder="Ej. 12"
              />
              {error && (
                <p className="error" role="alert" data-testid="cpl-manual-error">
                  {error}
                </p>
              )}
              <div className="form-actions">
                <button type="button" className="backlink" onClick={onBack} data-testid={`${testId}-volver`}>
                  Atrás
                </button>
                <button type="submit" className="btn btn-cta" data-testid="ver-mi-tarifa-btn">
                  Ver mi tarifa <span className="mk-estrella" aria-hidden="true" />
                </button>
              </div>
            </form>
          ) : (
            <motion.div variants={item} className="form-actions">
              <button type="button" className="backlink" onClick={onBack} data-testid={`${testId}-volver`}>
                Atrás
              </button>
              <button type="button" className="btn btn-cta" onClick={() => avanzar()} data-testid="ver-mi-tarifa-btn">
                Ver mi tarifa <span className="mk-estrella" aria-hidden="true" />
              </button>
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
